import React from 'react';
import PropTypes from 'prop-types';

import {AuthorDashboardConsumer} from '../AuthorDashboardProvider/AuthorDashboardConsumer.react';

import AuthorDashboardHeaderBio from './AuthorDashboardHeaderBio.react';
import AuthorDashboardHeaderStats from './AuthorDashboardHeaderStats.react';
import './author-dashboard-header.scss';

const AuthorDashboardHeader = ({shouldBreakHeader}) => {
  return (
    <AuthorDashboardConsumer field='data'>
      {(value) => {
        return (
          <div className='author-dashboard-header__container'>
            <AuthorDashboardHeaderBio data={value.data} isNewAuthor={value.isNewAuthor} />
            {shouldBreakHeader ? (
              <svg
                width='377'
                height='1'
                viewBox='0 0 377 1'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='u-mar-t_6 u-mar-b_6'
              >
                <line x1='377' y1='0.500122' y2='0.500122' stroke='#E1E4E6' />
              </svg>
            ) : (
              <svg
                width='1'
                height='145'
                viewBox='0 0 1 145'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <line x1='0.5' y1='0.000122048' x2='0.500006' y2='145' stroke='#E1E4E6' />
              </svg>
            )}
            <AuthorDashboardHeaderStats count={value.count} data={value.data} />
          </div>
        );
      }}
    </AuthorDashboardConsumer>
  );
};

AuthorDashboardHeader.propTypes = {
  shouldBreakHeader: PropTypes.bool
};

export default AuthorDashboardHeader;
